export default __webpack_public_path__ + "static/partnerSectionBackground-8b0e821776018a7c677dbe0880732def.png";